<template>
<el-container style="height: 100% ;width:100%; overflow: hidden">
  <el-header class="sys-header">
    <div class="titleContainer">
      <span class="sys-header-icon">
      </span>
      <span class="sys-header-title">{{ appName }}</span>
    </div>
    <div class="userContainer">
      <div class="user_btn_box">
        <el-dropdown style="line-height: 60px;" @command="handleCommand">
          <span class="el-dropdown-link">
            <i class="el-icon-caret-bottom el-icon--right el-icon-user-solid user-btn"></i>
            {{username}}
            <i class="el-icon-caret-bottom el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item icon="el-icon-remove" command="editpwd">修改密码</el-dropdown-item>
            <el-dropdown-item icon="el-icon-remove" command="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </el-header>
  <div id="mapContainer" class="mapContainer">
    <div id="map" style="height: 100%;width: 100%"></div>
    <map-botton-bar ref="bootom_info_bar"></map-botton-bar><!--系统地图当前级别,位置,地名信息-->
    <!-- <cooperative-search></cooperative-search>左上角搜索 -->
    <div class="enterprise_select_container">
      <el-select
        v-model="currentEnterpriseNumber"
        placeholder="请选择"
        @change="selectEnterprise"
        filterable
        class="enterprise_select"
      >
        <el-option
          v-for="item in dataList"
          :key="item.enterpriseNumber"
          :label="item.enterpriseName||'--'"
          :value="item.enterpriseNumber"
        >
        </el-option>
      </el-select>
    </div>
    <div class="detail_board" v-show="ifShowDetail">
      <div class="detail_title">{{currentEnterprise.enterpriseName||'--'}}</div>
      <div class="close_btn" @click="detailClose">
        <i class="el-icon-close"></i>
      </div>
      <detail-board></detail-board>
    </div>
  </div>
  <div class="back_btn" @click="backHome" title="返回首页">
    <i class="el-icon-arrow-left"></i>
  </div>
</el-container>
</template>
<script>
import mapboxgl from 'mapbox-gl';
import turf from 'turf'
import Cookies from 'js-cookie';
import MapBottonBar from "@/components/uiComponents/mapBottonBar";
import cooperativeSearch from "@/components/mapElementBox/cooperativeSearch"
import detailBoard from "./detailBorad.vue"
import API from "@/api/serviceOrgManagement/api_userManagement";
import {diff, validate} from '@mapbox/mapbox-gl-style-spec';
export default {
  components: {
    MapBottonBar,
    cooperativeSearch,
    detailBoard,
  },
  name: 'Map',
  data() {
    return {
      mapPermission: [],//地图权限
      ifShowDetail: false,
      drawId: "",
      drawObj: "",
      contractObj:"",
      dataList: [], // 主体列表数据
      qhdm: Cookies.get("areacode"),
      currentEnterpriseNumber: '', // 主体代码
      currentEnterprise: {}, // 当前选中的主体
      sublogo: require('../../../static/img/blue_local.png'),
      sub_green_logo: require('../../../static/img/local_green.png'),
      geojson: {
        type: "FeatureCollection",
        features: [],
      },
      appName: localStorage.getItem('userSysInfoAppName'),

      userIcon: "../../../static/img/img_tx.jpg",
      isCollapsed: true,
      username: Cookies.get("accountName"),
      areaCode: Cookies.get("curAreaCode"),
      checkList: [],
      headImg:require('../../../static/img/logohead.png'),
    }
  },
  mounted() {
    this.watcher = this.$store.watch(
      this.$store.getters.style,
      (newStyle, oldStyle) => {
        this.renderMap(newStyle, oldStyle)
      },
    )

  },
  created() {
    this.contractObj = this.$route.query.contractObj
    this.GLOBAL.eventBus.$on("winSizeChange", this.mapresize)
    this.initMap();

    // console.log("收到的参数")
    // console.log(JSON.parse(this.$route.query.contractObj))
    // let coordinates = JSON.parse(this.$route.query.contractObj).coordinates;

  },
  methods: {
    handleCommand(command) {
      if (command == "logout") {
        this.logout();
      }
    },
    logout: function () {
      let that = this;
      this.$confirm("是否要注销当前登录" + this.username + "用户?", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.$router.push({ path: "/login" });
        })
        .catch(() => {});
    },
    locate(data) {
        if (!this.GLOBAL.map) {
            return
        }

        console.log('data', data)
        if (data) {
            let geojson = JSON.parse(data)
            console.log(geojson)

            //构造数据源
            let source = this.GLOBAL.map.getSource('geojson-preview-source')
            if (source) {
                source.setData({
                    'type': 'Feature',
                    'geometry': geojson,
                })
            } else {
                this.GLOBAL.map.addSource('geojson-preview-source', {
                    type: 'geojson',
                    data: {
                        'type': 'Feature',
                        'geometry': geojson,
                    }
                })
            }
            //图层
            if (!this.GLOBAL.map.getLayer('preview-dk-layer')) {
                this.GLOBAL.map.addLayer({
                    'id': 'preview-dk-layer',
                    'type': 'fill',
                    'source': 'geojson-preview-source',
                    'paint': {
                        'fill-color': '#e4df17',
                    }
                })
            }

            //定位
            let e_bound = turf.bbox(geojson);
            let bounds = new mapboxgl.LngLatBounds(new mapboxgl.LngLat(e_bound[0], e_bound[1]), new mapboxgl.LngLat(e_bound[2], e_bound[3]));
            this.GLOBAL.map.fitBounds(bounds, {padding: {top: 100, bottom: 100, left: 0, right: 0}});//设置地图定位范围
        } else {
          /*  this.$message.error('该地块无geojson数据')*/
        }

    },
    mapresize() {
      let map = this.GLOBAL.map;
      if (map) {
        setTimeout(() => {
          map.resize();
        }, 500)
      }
    },


    renderMap(newStyle, oldStyle) {
      let map = this.GLOBAL.map;
      if (!map) {
        return
      }
      ;
      let comds = diff(oldStyle, newStyle);
      for (let i = 0, length = comds.length; i < length; i++) {
        switch (comds[i].command) {
          case 'setPaintProperty':
            map.setPaintProperty.apply(map, comds[i].args);
            break;
          case 'setLayoutProperty':
            map.setLayoutProperty.apply(map, comds[i].args);
            break;
          case 'setStyle':
            map.setStyle.apply(map, comds[i].args);
            break;
          case 'addLayer':
            map.addLayer.apply(map, comds[i].args);
            break;
          case 'removeLayer':
            map.removeLayer.apply(map, comds[i].args);
            break;
          case 'setFilter':
            map.setFilter.apply(map, comds[i].args);
            break;
          case 'setLayerZoomRange':
            map.setLayerZoomRange.apply(map, comds[i].args);
            break;
          case 'setLayerProperty':
            map.setLayerProperty.apply(map, comds[i].args);
            break;
          case 'addSource':
            map.addSource.apply(map, comds[i].args);
            break;
          case 'removeSource':
            map.removeSource.apply(map, comds[i].args);
            break;
        }
      }
    },
    //初始化地图
    initMap() {
      let _that = this;
      this.$axios.get(process.env.MAPID).then(res => {
        console.log('res', res.data)
          let style = res.data
          this.$store.commit('patch_style', style)
          let map = new mapboxgl.Map({
            container: 'map',
            style: res.data,
            maxZoom: 17.99,
            transformRequest: (url, resourceType) => {
              if (url.includes('mse.gykj.com.cn') || url.includes("mse.agribigdata.com.cn")) {
                return {
                  url: url,
                  headers: {"Authorization": Cookies.get("token")},
                }
              } else {
                return {
                  url: url,
                }
              }
            }
          });

          map.on("load", () => {
            this.getDataList();
            this.$refs.bootom_info_bar.init("map");
            /*初始化地图底部信息框*/
            this.GLOBAL.eventBus.$emit("mapLoaded");
            /*触发地图加载完毕事件,其余需要地图加载后的初始化代码监听*/

            //初始化定位
            this.GLOBAL.locateXzq({
              "xzqcode": Cookies.get("areacode"),
              "boundsOptions": {
                padding: 10,
                maxZoom: this.GLOBAL.getZoomByAreaCode(Cookies.get("areacode")) - 0.1
              }
            })
          })
          this.GLOBAL.map = map;

          //防止canvas渲染不完整
          map.on('styledata', () => {
            map.resize();
          });
          //导航条
          map.addControl(new mapboxgl.NavigationControl(), 'bottom-left');
          //比例尺
          map.addControl(new mapboxgl.ScaleControl({maxWidth: 80, unit: 'metric'}), 'bottom-left');
          setTimeout(function () {
              _that.locate(_that.contractObj)
          }, 500)

        }
      ).catch(error => {
        console.log(error);
      });
    },
    selectEnterprise(){
      let obj = this.dataList.filter(item=>{
        return item.enterpriseNumber==this.currentEnterpriseNumber;
      })
      console.log("obj",obj,this.currentEnterpriseNumber)
      this.currentEnterprise = {...obj[0]}
      this.GLOBAL.eventBus.$emit("selectEnterprise", this.currentEnterpriseNumber,obj[0].year)
      let map = this.GLOBAL.map;
      map.setFilter("enterprise_heightLight", ["==", "enterpriseNumber", this.currentEnterpriseNumber]);
      let curZoom = map.getZoom();
      let targetZoom = curZoom>=15? curZoom:15;
      map.flyTo({
        center: [this.currentEnterprise.lgd,this.currentEnterprise.ltd],
        zoom: targetZoom,
      })
      this.ifShowDetail = true;
    },
    async getDataList(){
      let params = {
        qhdm: this.qhdm,
        pageSize: 1000,
      }
      const { code, data } = await API.priseList(params);
      if (code === 0) {
        this.dataList = data.unauditeList;
        this.geojson = {
          type: "FeatureCollection",
          features: [],
        }
        this.dataList.forEach(item=>{
          if(item.lgd && item.ltd){
            let jsonData = {
              type: "Feature",
              properties: {...item},
              geometry: {
                type: "Point",
                coordinates:[item.lgd, item.ltd]
              }
            }
            this.geojson.features.push(jsonData)
          }
        })
        this.drawMarkerLayer();
        this.drawHighlightLayer();
      }else{
        this.dataList = []
      }
    },
    drawMarkerLayer(){
      let that = this;
      let map = that.GLOBAL.map;
      map.loadImage(
        that.sublogo, /*默认图标*/
        function (error, image) {
          if (error) throw error;
          if (map.hasImage('lightcyFlg')) {
            map.removeImage('lightcyFlg');
          }
          map.addImage('lightcyFlg', image);   /*, {sdf: true}*/
        }
      )
      map.addSource("entities", {
        type: "geojson",
        data: that.geojson,
      });
      map.loadImage(
        that.sublogo, /*默认图标*/
        function (error, image) {
          if (error) throw error;
          if (map.hasImage('lightcyFlg')) {
            map.removeImage('lightcyFlg');
          }
          map.addImage('lightcyFlg', image);
        }
      )
      if (!map.getLayer("enterpriseLevel_heightLight")) {
        map.addLayer({
          id: 'enterpriseLevel_heightLight',
          type: 'symbol',
          "source": "entities",
          "maxzoom": 18,
          "minzoom": 5,
          "filter": ["!=", "a", "b"],
          'layout': {
            'icon-image': 'lightcyFlg',
            'icon-size': 1,
          },
        });
        map.on("click", "enterpriseLevel_heightLight", this.markerLayerClick)
      }
    },
    drawHighlightLayer(){
        let that = this;
        let map = that.GLOBAL.map;
        //高亮
        map.loadImage(
          that.sub_green_logo,//高亮图片
          function (error, image) {
            if (error) throw error;
            if (map.hasImage('lightlyFlg')) {
              map.removeImage('lightlyFlg');
            }
            map.addImage('lightlyFlg', image);
          })
        if (!map.getLayer("enterprise_heightLight")) {
          map.addLayer({
            id: 'enterprise_heightLight',
            type: 'symbol',
            "source": "entities",
            "maxzoom": 18,
            "minzoom": 5,
            "filter": ["==", "a", "b"],
            'layout': {
              'icon-image': 'lightlyFlg',
              'icon-size': 1.2,
            },
          });
        }
      },
    markerLayerClick(e){
      console.log('eee', e)
      let map = this.GLOBAL.map;
      let feature = e.features[0];
      let objectid = feature.properties.enterpriseNumber;
      map.setFilter("enterprise_heightLight", ["==", "enterpriseNumber", objectid]);
      this.currentEnterprise = {...feature.properties};
      this.currentEnterpriseNumber = this.currentEnterprise.enterpriseNumber;
      this.GLOBAL.eventBus.$emit("selectEnterprise", this.currentEnterpriseNumber)
      let curZoom = map.getZoom();
      let targetZoom = curZoom>=15? curZoom:15;
      map.flyTo({
        center: [this.currentEnterprise.lgd,this.currentEnterprise.ltd],
        zoom: targetZoom,
      })
      this.ifShowDetail = true;
    },
    detailClose(){
      this.ifShowDetail = false;
    },
    backHome(){
      this.$router.push('/homepage/home');
    }
  },
  beforeDestroy() {
    this.GLOBAL.map = null;
    this.GLOBAL.eventBus.$off("winSizeChange", this.mapresize)
  }
};
</script>
<style lang="less">
  @import "../../../node_modules/mapbox-gl/dist/mapbox-gl.css";
  .mapContainer{
    width: 100%;
    height: calc(100% - 60px);
    box-sizing: border-box;
    position: relative;
  }
  .enterprise_select_container{
    position: absolute;
    top: 20px;
    right: 20px;
    .el-select{
      width: 560px;
    //   input {
    //     background-color: rgba(5, 34, 56, 0.7) !important;
    //     border-color: #00D8FF !important;
    //     //border: none;
    //     color: #00D2FF !important;
    //   }
    //   //图标样式
    //   .el-input__prefix, .el-input__suffix{
    //     color: #00D2FF !important;
    //   }
    // //select选择框箭头
    //   .el-input .el-select__caret{
    //     color: #00D2FF !important;
    //   }
    }
  }
  .detail_board{
    position: absolute;
    right: 20px;
    top: 80px;
    width: 560px;
    height: calc(100% - 120px);
    background-color: #fff;
    border-radius: 4px;
    // background: rgba(5, 34, 56, 0.8);
    .detail_title{
      background-color: #0EAC79;
      width: 100%;
      height: 36px;
      line-height: 36px;
      font-size: 16px;
      font-weight: 600;
      color: #fff;
      padding-left: 16px;
      box-sizing: border-box;
      border-radius: 4px 4px 0 0;
    }
    .close_btn{
      position: absolute;
      top: 8px;
      right: 8px;
      font-size: 14px;
      color: #fff;
      cursor: pointer;
      &:hover{
        color: #eaeaea;
      }
    }
  }
  .back_btn{
    position: absolute;
    top: 80px;
    left: 20px;
    z-index: 9;
    width: 36px;
    height: 36px;
    line-height: 36px;
    background-color: #0EAC79;
    color: #fff;
    font-size: 16px;
    text-align: center;
    cursor: pointer;
    border-radius: 50%;
    &:hover{
      background-color: #119369;
    }
  }
</style>
<style lang="less" scoped>
.iconfont{
  height: 60%;
  vertical-align: middle;
  // width: 100%;
}


.sys-header {
  background-color: #0EAC79;
  //  background: linear-gradient(to right, #262d38, #727270);
  height: 50px;
  vertical-align: middle;
}

.sys-header{
  .titleContainer {
    float: left;
    line-height: 60px;
    height: 100%;
    width: 80%;
    .sys-header-title {
      font-weight: bold;
      font-size: 22px;
      color: #fff;
      line-height: 60px;
      display: inline-block;
      vertical-align: top;
    }
    .sys-header-icon {
      font-size: 28px;
      color: #fff;
    }
  }
  .userContainer {
    // height: 100%;
    display: flex;
    align-items:center;
    text-align: right;
    font-size: 28px;
    color: #fff;
    position: absolute;
    right: 20px;
    .el-dropdown-link{
      cursor: pointer;
      color: #fff;
      font-size: 18px;
      &:hover{
        color: #00ffff;
      }
      .user-btn{
        position: relative;
        font-size: 20px;
        margin:0 0 0 10px;
      }
    }
  }
}
.sys-header .userContainer .el-dropdown-link

.menuActive {
  transform: rotate(90deg);
}
</style>



// WEBPACK FOOTER //
// src/studio/oneMap/oneMap.vue